import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import useApi from '../../api/useApi';
import Moment from 'react-moment';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import moment from 'moment'; //Both are required here
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const PreviousPoolingReport = () => {
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [editPoolingDetail, setEditPoolingDetail] = useState({});
    const [isPoolingClosed, setIsPoolingClosed] = useState(false);
    const api = useApi();
    const [pooledLots, setPooledLots] = useState([]);
    const [auctionDetail, setAuctionDetail] = useState({});
    const [isAuctionScheduled, setIsAuctionScheduled] = useState(false);
    const [dealerQtyPercent, setDealerQtyPercent] = useState(0);
    const { id } = useParams();
    const [auctionId, setAuctionId] = useState(id);

    const planterDealerRenderer = (props) => {
        const planterOrDealer = (props.value === 1 ? "Planter" : (props.value === 2 ? "Dealer" : props.value));
        return (
            <span>{planterOrDealer} </span>
        );
    };

    const linkRenderer = (props) => {
        //const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                {/*<span role="button" className="custom-link" onClick={() => viewPoolingDetail(props.data.pooledLotId)}>*/}
                {/*    <button className="btn ripple btn-outline-primary btn-sm mb-b-4" type="button" >*/}
                {/*        View*/}
                {/*    </button>*/}
                {/*</span>*/}
                <button className="ms-2 btn ripple btn-outline-primary pd-x-10  btn-sm" type="button" onClick={() => downloadCropReceipt(props.node.data.pooledLotId)}>
                    <i class="ti ti-import "></i>
                </button>
            </span>
        );
    };

    const specialLotRenderer = (props) => {
        const isSpecialLot = (props.isSpecialLot === true ? "Yes" : (props.value === false ? "No" : props.value));

        return (
            <span>{isSpecialLot} </span>
        );
    };

    const poolingStatusRenderer = (props) => {
        const isClosed = (props.value === true ? "Pooling closed" : (props.value === false ? "Open" : props.value));
        return (
            <span>{isClosed} </span>
        );
    };

    const buttonRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span role="button" className="custom-link" onClick={() => downloadCropReceipt(props.node.data.pooledLotId)}>{cellValue}</span>
            </span>
        );
    };

    const columns = [
        { headerName: '', field: 'lotNumber', headerClass: 'text-center', cellClass: 'text-center', width: 60, cellRenderer: linkRenderer },
        { headerName: 'Lot No.', field: 'lotNumber', headerClass: 'text-center', cellClass: 'text-center', width: 40, },
        { headerName: 'Collection Center', field: 'collectionCenter', cellClass: 'text-center', width: 120 },
        { headerName: 'Planter/ Dealer', field: 'planterDealer', cellClass: 'text-center', width: 68, cellRenderer: planterDealerRenderer },
        { headerName: 'Planter Name', field: 'planterName', cellClass: '', width: 240 },
        { headerName: 'Planter Mobile Number', field: 'planterMobileNumber', width: 100 },
        { headerName: 'CRNO/ SBL No', field: 'crnosblNo', width: 'auto' },
        { headerName: 'Litre Weight (gm)', field: 'litreWeightGms', headerClass: 'text-center', cellClass: 'text-center', width: 64 },
        { headerName: 'No. of Bags', field: 'bags', headerClass: 'text-center', cellClass: 'text-center', width: 48 },
        { headerName: 'Qty (Kg)', field: 'quantityKg', headerClass: 'text-center', cellClass: 'text-center', width: 64 },
        { headerName: 'Grade Type', field: 'gradeType', cellClass: 'text-center', width: 60 },
        { headerName: 'Grade', field: 'grade', cellClass: 'text-center', width: 90 },
        { headerName: 'Moisture Content (%)', field: 'moistureContent', headerClass: 'text-center', cellClass: 'text-center', width: 78 },
        { headerName: 'Immature Seeds (%)', field: 'immatureSeeds', headerClass: 'text-center', cellClass: 'text-center', width: 78 },
        { headerName: 'Size', field: 'size', cellClass: 'text-center', width: 90 },
        { headerName: 'Colour', field: 'colour', cellClass: 'text-center', width: 90 },
        { headerName: 'Rejection', field: 'rejection', cellClass: 'text-center', width: 90 },
        { headerName: 'Is Speical Lot', field: 'isSpecialLot', cellClass: 'text-center', width: 90, cellRenderer: specialLotRenderer },
        { headerName: 'Start Price', field: 'auctionStartPriceRs', cellClass: 'text-center', width: 60 },
        { headerName: 'Res. Price', field: 'reservedPrice', cellClass: 'text-center', width: 60 },
        { headerName: 'Crop Receipt Number', field: 'cropReceiptNumber', cellClass: 'text-center', width: 250, cellRenderer: buttonRenderer },
        { headerName: 'Pooling Status', field: 'isPoolingClosed', cellClass: 'text-center', width: 140, cellRenderer: poolingStatusRenderer },
    ];

    const gridOptions = {
        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
        },
        columnDefs: columns,
        rowClass: 'custom-grid-font',
        getRowClass: params => {
            if (params.node.rowIndex % 2 === 0) {
                return 'bg-gray-50-i';
            }
        }
    };


    const loadPooledLots = async () => {
        try {
            const pooling = await api.getPooledLotsForAuctionAdmin(auctionId);
            if (pooling) {

                setIsPoolingClosed(pooling.isPoolingClosed);

                if (pooling.auctionId > 0) {

                    setIsAuctionScheduled(true);
                    setPooledLots(pooling.lotDetail);

                    //var anyClosedPooling = pooling.lotDetail?.findIndex(t => t.isPoolingClosed === true);
                    //if (anyClosedPooling > -1)
                    //    setIsPoolingClosed(true);

                    let totalQuantity = 0;
                    let dealerQuantity = 0;

                    pooling.lotDetail.forEach(detail => {
                        totalQuantity += detail.quantityKg;
                        if (parseInt(detail.planterDealer) === 2) {
                            dealerQuantity += detail.quantityKg;
                        }
                    });
                    const dealerQtyPercent = (dealerQuantity / totalQuantity) * 100;

                    setDealerQtyPercent(dealerQtyPercent.toFixed(2))


                    pooling.lotDetail = null;
                    setAuctionDetail(pooling);
                }
                else {
                    setIsAuctionScheduled(false);
                }
            }
            else {
                setIsPoolingClosed(true);
            }
            //setPooledLots(lotData);
            //var anyClosedPooling = lotData?.findIndex(t => t.isConsolidated === true);
            //if (anyClosedPooling > -1)
            //    setIsPoolingClosed(true);

        } catch (error) {
            alert('Unable to fetch pooled lot data.');
        }
    };

    useEffect(() => {
        loadPooledLots();
    }, []);


    const viewPoolingDetail = (pooledLotId) => {
        navigate(`/pooledLotDetail/${pooledLotId}?a=${auctionId}`);
    }; 

    const closePoolingAndForward = async () => {

        if (window.confirm('You won\'t be able to add/modify lots once you close the pooling. Are you sure you want to proceed?') === true) {
            await api.closePooling()
                .then((response) => {
                    if (response.success) {
                        loadPooledLots();
                        alert(response.message);
                    }
                    else
                        alert(response.message);
                })
                .catch((error) => {
                    console.error('Error closing pooling :', error);
                });
        }
    };


    const editStatus = (pooledLot) => {
        setEditPoolingDetail(pooledLot);
    }

    const downloadCropReceipt = async (id) => {

        const receiptData = await api.getCropReceipt(id);
        let rows = [];
        if (receiptData.isProvisionalCropReceipt === true)
            rows.push([{ text: "PROVISIONAL CROP RECEIPT", colSpan: 2, fontSize: 20, bold: true }, { text: "" }]);
        else
            rows.push([{ text: "CROP RECEIPT", colSpan: 2, fontSize: 20, bold: true }, { text: "" }]);

        rows.push([{ text: "Receipt No. " + receiptData.cropReceiptNumber, border: [true, false, false, true] }, { text: "Receipt Date : " + moment(receiptData.poolingDate).format('DD-MMM-YYYY'), alignment: "right", border: [false, false, true, true] }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5] }, { text: "" }]);
        rows.push([{ text: "POOLING DETAIL", bold: true, colSpan: 2, fillColor: "#a2bbdb" }, { text: "" }]);
        rows.push([{ text: "Name Of Planter / Dealer / Contact No : " }, { text: receiptData.planterName + " / " + receiptData.planterMobileNumber, bold: true }]);
        rows.push([{ text: "Pooling Centre : " }, { text: receiptData.centerName, bold: true }]);
        rows.push([{ text: "Date of Pooling : " }, { text: moment(receiptData.poolingDate).format('DD-MMM-YYYY'), bold: true }]);
        rows.push([{ text: "CRNO/SBL No : " }, { text: receiptData.crnosblNo, bold: true }]);
        rows.push([{ text: "Lot Number : " }, { text: receiptData.lotNumber, bold: true }]);
        rows.push([{ text: "Number of bags : " }, { text: receiptData.bags, bold: true }]);
        rows.push([{ text: "Net Weight : " }, { text: receiptData.quantityKg + " kg", bold: true }]);
        rows.push([{ text: "Litre weight : " }, { text: receiptData.litreWeightGms + " gram", bold: true }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5] }, { text: "" }]);
        rows.push([{ text: "AUCTIONEER DETAIL", bold: true, colSpan: 2, fillColor: "#a2bbdb" }, { text: "" }]);
        rows.push([{ text: "Auctioneer : " + receiptData.companyName, colSpan: 2 }, { text: "" }]);
        rows.push([{ text: "License No : " + receiptData.licenceNumber }, { text: "GST No : " + receiptData.gstNumber }]);
        rows.push([{ text: "Auction No. : " + receiptData.auctionNo }, { text: "Auction Date : " + moment(receiptData.auctionDate).format('DD-MMM-YYYY') }]);
        rows.push([{ text: "Payment Due Date : 10 days from the date of auction." }, { text: "" }]); //moment(receiptData.paymentDueDate).format('DD-MMM-YYYY') 
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5], border: [true, false, true, false] }, { text: "" }]);
        rows.push([{ text: "The Cardamom pooled with us will be sold through our auction subject to the terms and conditions of the Cardamom Auctioneer Licence issued by Spice Board. This Crop Receipt should be produced when claiming payment.", border: [true, false, true, false], colSpan: 2 }, { text: "" }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 40, 0, 40], border: [true, false, true, false] }, { text: "" }]);
        rows.push([{ text: "Customer Signature", alignment: "center", border: [true, false, false, false] }, { text: "Authorized Signatory", alignment: "center", border: [false, false, true, false] }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5], border: [true, false, true, false] }, { text: "" }]);
        rows.push([{ text: "Sample taken: 3 Kg\nIf the lot is sold : Payment will be made for : (" + receiptData.quantityKg + "kg - 150gm) = " + (receiptData.quantityKg - 0.15) + " Kg.\nIf the lot is withdrawn before bidding : Whole sample will be returned.\nIf the lot is withdrawn after bidding : Payment will be made for 3000 gm based on the average price of that auction or return the sample in the form of cardamom mixed with other samples.\nIf the lot is detected with artificial colour, 2900 gm sample will be returned.", fontSize: 10, margin: [0, 10, 0, 10], colSpan: 2, border: [true, false, true, true] }, { text: "" }]);
        rows.push([{ text: "Software by Boltware | www.boltware.in", fontSize: 6, margin: [0, 20, 0, 20], colSpan: 2, border: [false, false, false, false] }, { text: "" }]);


        let body = rows;
        const documentDefinition = {
            content: [
                {
                    style: 'tableExample2',
                    table: {
                        //widths: [222,222],
                        body: body
                    }, layout: {
                        paddingLeft: (i, node) => 5,
                        paddingRight: (i, node) => 5,
                        paddingTop: (i, node) => 5,
                        paddingBottom: (i, node) => 5
                    }
                },
            ],
            styles: {
                tableExample2: {
                    width: '100%',
                    fontSize: 10, // Set the font size for the table
                },
            }
        };
        let filename = "Crop-Receipt-" + receiptData.cropReceiptNumber + ".pdf"
        pdfMake.createPdf(documentDefinition).download(filename);
    }


    return (
        <div>
            <div className="inner-body">
                <div className="page-header">
                    <div>
                        <h2 className="main-content-title tx-24 mg-b-5">Pooled Lots</h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"> <a className="custom-link" onClick={() => navigate('/auctioneer')}>Home</a></li>
                            <li className="breadcrumb-item" > <a className="custom-link" onClick={() => navigate(-1)}>Auction History</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Pooling Detail</li>
                        </ol>
                    </div>
                    <div className="d-flex">
                        {isAuctionScheduled === true && isPoolingClosed === false ?
                            <div className="justify-content-center">
                                {/*<button type="button" className="btn btn-success my-2 btn-icon-text" onClick={closePoolingAndForward}>*/}
                                {/*    <i className="fe fe-edit me-2"></i> Close pooling & forward lots for auction.*/}
                                {/*</button>*/}
                            </div> :
                            isAuctionScheduled === true && isPoolingClosed === true ?
                                <div><span style={{ fontSize: '13px' }} className="badge rounded-pill bg-success p-2 mg-b-5"> Pooling has been closed & lots has been forwarded for auction.</span></div>
                            :null
                        }
                    </div>

                    
                </div>
                <div className="row row-sm">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                        <div className="card custom-card">

                            {isAuctionScheduled === true ?
                                <div className="card-body">
                                    <div className="d-flex justify-content-between">
                                        <div className={dealerQtyPercent>=25?"d-flex text-danger":"d-flex"}>
                                            {dealerQtyPercent >= 25 ? <span><i class="ti ti-alert  fs-2 fw-600"></i></span> : null}
                                            <span className="me-2">Dealer Quantity : </span>
                                            <h2>{dealerQtyPercent}%</h2> 
                                        </div>
                                         <div className="d-flex ">
                                            <span className="me-2">Max dealer quantity allowed per auction : </span>
                                            <h2 >25%</h2>
                                        </div>
                                    </div>
                                    <div
                                        style={{ height: '90vh' }}
                                        className={
                                            "ag-theme-alpine"
                                        }
                                    >
                                        <AgGridReact gridOptions={gridOptions} rowData={pooledLots} /></div>
                                </div> :
                                <div className="card-body">
                                    <span style={{ fontSize: '13px' }} className="badge rounded-pill bg-danger p-2 mg-b-5">No auctions schedule available. </span>
                                    <h5 className="mg-t-6">Pooling is allowed only upto 2 days prior to schedule of the auction date. </h5>
                                    <p>Please contact Spices Board or check again later.</p>
                                </div>}

                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default PreviousPoolingReport;